import { Injectable,Inject } from '@angular/core';
import { AppConfig, AppConfiguration } from 'src/configuration';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class TeachingCommentService {
  constructor(
    @Inject(AppConfig) private readonly appConfig: AppConfiguration,
    private http: HttpClient) { }

  List(res, token) : Observable<any>{
    return this.http.post<any>(this.appConfig.TeacherUrl + 'TeachingComment/TeachingCommentList',res,{
      headers: new HttpHeaders()
        .set('Authorization', `Bearer ${token}`)
    } ).pipe(map(z=> {return z}))  
  }

  Update(res, token) : Observable<any>{
    return this.http.post<any>(this.appConfig.TeacherUrl + 'TeachingComment/Update',res,{
      headers: new HttpHeaders()
        .set('Authorization', `Bearer ${token}`)
    } ).pipe(map(z=> {return z}))  
  }

  Insert(res, token) : Observable<any>{
    return this.http.post<any>(this.appConfig.TeacherUrl + 'TeachingComment/Insert',res,{
      headers: new HttpHeaders()
        .set('Authorization', `Bearer ${token}`)
    } ).pipe(map(z=> {return z}))  
  }

  Delete(res, token) : Observable<any>{
    return this.http.post<any>(this.appConfig.TeacherUrl + 'TeachingComment/Delete',res,{
      headers: new HttpHeaders()
        .set('Authorization', `Bearer ${token}`)
    } ).pipe(map(z=> {return z}))  
  }

  CheckExist(res, token) : Observable<any>{
    return this.http.post<any>(this.appConfig.TeacherUrl + 'TeachingComment/CheckExist',res,{
      headers: new HttpHeaders()
        .set('Authorization', `Bearer ${token}`)
    } ).pipe(map(z=> {return z}))  
  }

  TeachingCommentExport(req, token) : Observable<any>{
    return this.http.post<any>(this.appConfig.TeacherUrl + 'TeachingComment/TeachingCommentExport',req,{
      headers: new HttpHeaders()
        .set('Authorization', `Bearer ${token}`)
    } ).pipe(map(z=> {return z}))
  }
}